import { defineMessages } from 'react-intl';
import { I18nKeys } from '../../i18n/keys';

export const GroupListMessages = defineMessages({
  groups: {
    id: I18nKeys.GroupList,
    defaultMessage: 'Groups',
  },
  nameRequiredError: {
    id: I18nKeys.GroupListNameRequiredError,
    defaultMessage: 'Group name is required',
  },
  descriptionRequiredError: {
    id: I18nKeys.GroupListDescriptionRequiredError,
    defaultMessage: 'Group description is required',
  },
});
